var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "uploadVideo" }, [
    !_vm.url && !_vm.isUp
      ? _c("div", { staticClass: "videoBox" }, [
          _c(
            "div",
            { staticClass: "upVideo", on: { click: _vm.inputChange } },
            [_c("i", { staticClass: "el-icon-plus" })]
          )
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "videoBox" },
      [
        _vm.isUp
          ? _c("el-progress", {
              attrs: {
                type: "circle",
                width: 200,
                percentage: _vm.videoUploadPercent
              }
            })
          : _vm._e()
      ],
      1
    ),
    _vm.url
      ? _c("video", {
          staticClass: "videoAvatar",
          attrs: { id: "vide", src: _vm.url, controls: "controls" }
        })
      : _vm._e(),
    _c(
      "div",
      { staticClass: "optionBtn" },
      [
        _vm.url
          ? _c(
              "el-button",
              {
                attrs: { type: "primary", size: "small" },
                on: { click: _vm.inputChange }
              },
              [_vm._v("重新上传")]
            )
          : _vm._e(),
        _vm.isUp
          ? _c(
              "el-button",
              {
                attrs: { type: "danger", size: "small" },
                on: { click: _vm.cancelUp }
              },
              [_vm._v("取消上传")]
            )
          : _vm._e()
      ],
      1
    ),
    _vm._m(0),
    _c("input", {
      ref: "inputer",
      staticClass: "inputer",
      attrs: { type: "file", accept: "video/*" },
      on: { change: _vm.httpRequest }
    })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "Upload_pictures" }, [
      _c("span", [
        _vm._v("最多可以上传1个视频，建议大小50M，推荐格式mp4,点击视频重新上传")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }